import { useSelector } from 'react-redux';
import { useEffect, useMemo } from 'react';
import {
    SORT_BLINDS_HIGH_LOW,
    SORT_BLINDS_LOW_HIGH,
    SORT_PLAYERS_HIGH_LOW,
    SORT_PLAYERS_LOW_HIGH
} from '@/Poker/data/Constants';

export default function useGameTypeRooms() {
    const masterRoomsObject = useSelector((state) => state.lobby.masterRoomsObject);
    const cashLobbyFilterSortConfig = useSelector((state) => state.lobby.cashLobbyFilterSortConfig);
    const gameType = useSelector((state) => state.lobby.cashLobbyActiveTab.gameType);
    const channel = useSelector((state) => state.lobby.channel);

    const filteredSortedRoomIds = useMemo(() => {
        if (!masterRoomsObject || typeof masterRoomsObject !== 'object') return [];

        let roomsArray = Object.entries(masterRoomsObject).map(([roomId, roomData]) => ({
            roomId,
            ...roomData
        }));

        // Filter by channels applicable
        if (channel) {
            roomsArray = roomsArray.filter(room => {
                return room.channelApplicable?.includes(channel)
            });
        }

        // Filter by active game type
        if (gameType) {
            roomsArray = roomsArray.filter(room => room.gameType === gameType);
        }

        // Favorites filter
        if (cashLobbyFilterSortConfig.favorites) {
            roomsArray = roomsArray.filter(room => room.isFavorite);
        }

        // Stakes filter
        if (cashLobbyFilterSortConfig.appliedStakes?.length > 0) {
            roomsArray = roomsArray.filter(room => {
                const bb = Number(room.bigBlind) || 0;
                return cashLobbyFilterSortConfig.appliedStakes.some(stake =>
                    (stake === 'low' && bb <= 10) ||
                    (stake === 'mid' && bb > 10 && bb <= 200) ||
                    (stake === 'high' && bb > 200)
                );
            });
        }

        // Sorting
        switch (cashLobbyFilterSortConfig.sortBy) {
            case SORT_BLINDS_LOW_HIGH:
                roomsArray.sort((a, b) => (a.bigBlind || 0) - (b.bigBlind || 0));
                break;
            case SORT_BLINDS_HIGH_LOW:
                roomsArray.sort((a, b) => (b.bigBlind || 0) - (a.bigBlind || 0));
                break;
            case SORT_PLAYERS_LOW_HIGH:
                roomsArray.sort((a, b) => (a.onlineCount || 0) - (b.onlineCount || 0));
                break;
            case SORT_PLAYERS_HIGH_LOW:
                roomsArray.sort((a, b) => (b.onlineCount || 0) - (a.onlineCount || 0));
                break;
            default:
                break;
        }

        return roomsArray.map(room => room.roomId);
    }, [masterRoomsObject, channel, gameType, cashLobbyFilterSortConfig.favorites, cashLobbyFilterSortConfig.sortBy, cashLobbyFilterSortConfig.appliedStakes]);

    // useEffect(() => {
    //     console.log('Spruha log >>> Master Rooms Object is >>> ', masterRoomsObject);
    //     console.log('Spruha log >>> Filters are >>> ', cashLobbyFilterSortConfig)
    //     console.log('Spruha log >>> Filtered Sorted Room IDS >>> ', filteredSortedRoomIds)
    // }, [masterRoomsObject, cashLobbyFilterSortConfig])


    return filteredSortedRoomIds;
}
